// Modelo Compañia para administrador.
export default class PatientEvolution {
    fecha={}
    notas=""
    diagnosticos=[]
    prescripcionIndicaciones=[]
    prescripcion= ""
    indicaciones= ""

}


// WEBPACK FOOTER //
// ./src/model/PatientEvolution.js